<header class=hero>
    <div class="hero-content">
        <div class="logo">
            <p></p>
        </div>
        <div class="hero-text"> 
            <h1>DOSIMETRÍA</h1><h2>nuestro servicio</h2>
        </div>  
    </div>
</header>
